import { useEffect } from 'react';

/**
 * Doosri taraf se kuch badle to data dobara laao.
 *
 * ⚠️ DO MAUKE PE chalta hai, dono ka server pe kharcha ZERO:
 *
 *   1. Service worker se DATA_CHANGED aaye - yaani push aayi.
 *      Push waise bhi ja rahi hai, ye bas usi pe sawaar hai.
 *
 *   2. User doosre tab se WAPAS aaye. Ye sabse aam sthiti hai -
 *      user booking karke doosre tab mein chala gaya, laut ke aaya,
 *      aur data taaza mil gaya.
 *
 * ⚠️ KOI TIMER NAHI, koi polling nahi. Baar-baar server ko poochhne
 *    se bojh badhta hai aur zyadatar baar jawab wahi hota hai.
 *
 * @param onRefresh data dobara laane wala function
 */
export const useLiveRefresh = (onRefresh) => {
    useEffect(() => {
        if (typeof onRefresh !== 'function') return;

        // 1. Service worker se sandesh
        const onMessage = (event) => {
            if (event.data && event.data.type === 'DATA_CHANGED') {
                onRefresh();
            }
        };

        // 2. Tab pe wapas aana
        //
        // ⚠️ 'visible' hone par hi - chhupe hue tab ka data laana
        //    bekaar hai, user dekh hi nahi raha.
        const onVisible = () => {
            if (document.visibilityState === 'visible') {
                onRefresh();
            }
        };

        navigator.serviceWorker?.addEventListener('message', onMessage);
        document.addEventListener('visibilitychange', onVisible);

        return () => {
            navigator.serviceWorker?.removeEventListener('message', onMessage);
            document.removeEventListener('visibilitychange', onVisible);
        };
    }, [onRefresh]);
};